import Vue from "vue";
import VueI18n from "vue-i18n";
import { messages } from "@/_utils/lang";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "it", // iniziale, verrà aggiornato dopo in main.js
  fallbackLocale: "it",
  messages,
});

export default i18n;